import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SocialMedia from "elements/social/SocialMedia";
import { FC } from "react";
import { Helmet } from "react-helmet";
import { BiSolidLike } from "react-icons/bi";
import { FaAward, FaHandPointer } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import img1 from "../../images/aboutus1.png";
import img2 from "../../images/aboutus2.png";
import GridSectionHero from "./GridSectionHero";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  const navigate = useNavigate();
  return (
    <div className={`nc-PageAbout overflow-hidden relative ${className}`} data-nc-id="PageAbout">
      <Helmet>
        <title>
          Espaces événementiels Paris, Île-de-France et partout en France : trouvez le lieu idéal | Event To Bee
        </title>
        <meta
          title="Location salle événement | Event To Bee"
          name="description"
          content="Découvrez la location des espaces événementiels  pour votre événement en. Simple et pas cher. Lofts, jardins, salles de réception, studios, etc. Réservez en quelques clics !"
        />
      </Helmet>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      <div className="slider-area rbt-banner-10 height-500 bg_image bg_image--11 " data-white-overlay="4">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-28 mt-lg-28 inner">
                <h1 className="text-3xl font-bold text-center text-white md:text-5xl lg:text-7xl">
                  À propos de nous
                </h1>
                <div className="mt-5 read-more-btn md:mt-4 lg:mt-4">
                  <span className="text-2xl text-white btn-text">
                    Créez, partagez, célébrez — nous trouvons le lieu
                  </span>
                </div>
              </div>
            </div>
          </div>
          <SocialMedia classOne="rbt-social-area rbt-section-gap" classList="social-icon social-default" />
        </div>
      </div>

      <div className="container py-16 space-y-16 lg:py-28 lg:space-y-28">
        <GridSectionHero
          imgWidth="60%"
          subHeading="Event To Bee est bien plus qu'une simple plateforme de location événementielle ; c'est une passerelle vers des expériences uniques et mémorables. Notre mission est de faciliter la recherche d'espaces atypiques et authentiques pour tous types d'événements, qu'il s'agisse d'un anniversaire, d'un cocktail élégant, d'un shooting photo ou simplement d'une réunion entre amis."
          rightImg={img1}
          btnText=""
          heading="EVENT TO BEE est une jeune plateforme française, qui facilite la recherche et la réservation d’espaces authentiques et atypiques propices à l’organisation d’événements, qu'il s'agisse d'un anniversaire, d'un cocktail élégant, d'un shooting photo ou simplement d'une réunion entre amis..."
        />
      </div>

      <div className="container pt-16">
        <h2 className="text-3xl font-bold text-dark dark:text-white">Notre Histoire</h2>
        <div className="mt-4">
          <p className={`block text-base xl:text-md text-neutral-6000 dark:text-white `}>
            Event To Bee est née d’un constat simple : trouver un espace événementiel est souvent un véritable
            parcours du combattant. Entre la recherche d’un lieu adapté, les critères de localisation, de capacité,
            de style, de tarifs et les démarches administratives, tout devient vite complexe.
          </p>

          <p className={`block text-base xl:text-md text-neutral-6000 dark:text-white `}>
            Nous avons donc créé Event To Bee pour simplifier ce processus. Que vous soyez un professionnel
            cherchant un lieu pour une conférence, un séminaire d’entreprise, un lancement de produit, ou un
            particulier organisant une réception privée ou un mariage, notre plateforme vous offre un accès rapide
            et efficace à une sélection variée d’espaces exceptionnels : lofts, villas, jardins, salles de
            réception, péniches, rooftops, studios photo,etc.
          </p>

          <p className={`block text-base xl:text-md text-neutral-6000 dark:text-white `}>
            Nous nous engageons à vous offrir une expérience simple, sécurisée et fluide pour trouver le lieu idéal
            correspondant à votre événement.
          </p>
        </div>
      </div>

      <div className="container py-16 mt-16">
        <div className="flex flex-col items-center justify-between md:flex-row">
          <div className="w-full space-y-6 md:w-1/2">
            <h2 className="text-3xl font-bold text-dark dark:text-white">
              La Location de lieux événementiels autrement
            </h2>
            <div className="p-6 bg-white rounded-lg shadow-md dark:bg-neutral-800">
              <div className="flex items-start space-x-4">
                <div className="flex items-center justify-between space-x-4">
                  <div>
                    <span className="text-eventToBee">
                      <FaAward className="w-10 h-10" />
                    </span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-black dark:text-white">Louez avec confiance</h3>
                    <p className="dark:text-white">
                      Nous sélectionnons uniquement des lieux vérifiés et sécurisés, avec des hôtes fiables.
                      Participez à un processus simple et rapide, Notre objectif est de vous garantir une
                      expérience de qualité et sans mauvaise surprise. Chaque espace est soigneusement évalué pour
                      répondre aux critères de sécurité, d’accessibilité et de confort.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-6 bg-white rounded-lg shadow-md dark:bg-neutral-800">
              <div className="flex items-start space-x-4">
                <div className="flex items-center justify-between space-x-4">
                  <div>
                    <span className="text-eventToBee">
                      <FaHandPointer className="w-10 h-10" />
                    </span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-black dark:text-white">
                      Flexibilité et large choix d’espaces
                    </h3>
                    <p className="dark:text-white">
                      Grâce à notre plateforme, vous disposez d’une grande liberté de choix : capacité d’accueil,
                      style de lieu, type d’événement, horaires. Que vous recherchiez un lieu pour un séminaire
                      d’entreprise, un mariage, un shooting photo ou une soirée d’entreprise, vous pouvez comparer
                      les offres, discuter directement avec les hôtes et trouver l’espace qui correspond
                      parfaitement à votre projet.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-6 bg-white rounded-lg shadow-md dark:bg-neutral-800">
              <div className="flex items-start space-x-4">
                <div className="flex items-center justify-between space-x-4">
                  <div>
                    <span className="text-eventToBee">
                      <BiSolidLike className="w-10 h-10" />
                    </span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold dark:text-white">Trouvez votre lieu idéal facilement</h3>
                    <p className="dark:text-white">
                      La location d'un espace événementiel pour un événement est désormais simplifiée grâce à notre
                      plateforme intuitive. Filtrez par localisation, type de lieu ou capacité d’accueil pour
                      trouver facilement et rapidement l’espace idéal, qu’il s’agisse d’un lieu atypique, d’un
                      espace professionnel ou d’un site prestigieux.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <img src={img2} alt="Event Venue" className="w-full h-full" />
          </div>
        </div>
      </div>

      <div className="container pt-16">
        <div className="flex flex-col items-center justify-between md:flex-row">
          <div className="w-full space-y-6 md:w-1/3">
            <h2 className="text-3xl font-bold text-dark">
              {" "}
              Pourquoi nous faire confiance pour louer un espace pour votre événement ?
            </h2>
          </div>
          <div className="md:w-1/2">
            <p>
              Event To Bee, c’est une plateforme reconnue pour la location des espaces événementiels. Nous avons
              aidé des centaines de clients à trouver le lieu parfait pour leurs projets. Nos partenaires sont
              soigneusement sélectionnés pour vous garantir une qualité de service irréprochable, que ce soit pour
              un événement professionnel ou privé. Nous mettons un point d’honneur à vous accompagner tout au long
              du processus de réservation pour que votre expérience soit simple, fluide et sécurisée. En cas de
              besoin, notre service client est là pour vous aider à chaque étape.
            </p>
          </div>
        </div>
      </div>

      <div className="container py-16 mt-16">
        <div className="flex flex-col items-center justify-center">
          <div className="space-y-6 text-center">
            <h2 className="text-3xl font-bold text-dark dark:text-white">
              Organisez votre événement avec <br />
              <span className="relative">
                Event To
                <span className="absolute bottom-0 left-0 right-0 h-1 bg-eventToBeePink"></span>
              </span>{" "}
              Bee
            </h2>
            <p className="max-w-2xl mx-auto text-black dark:text-white ">
              Ne remettez pas la location de salle pour votre événement à plus tard ! Découvrez dès maintenant
              notre sélection d’espaces uniques et réservez celui qui vous convient en toute simplicité.
            </p>
            <div className="flex justify-center mt-6 space-x-4">
              <ButtonPrimary
                onClick={() => navigate("/espace-evenementiel")}
                className="px-6 py-3 font-semibold transition text-dark "
              >
                Explorez les espaces
              </ButtonPrimary>
              <ButtonSecondary
                onClick={() => navigate("/prestations")}
                className="px-6 py-3 font-semibold transition rounded-full text-dark "
              >
                Trouvez un prestataire
              </ButtonSecondary>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAbout;
